const LOADER_START_DELAY = 150;
const LOADER_STOP_DELAY = 150;

window.loader = {
	show: false
};

const loader = {
	pendingRequestsNumber: 0,
	stopTimerID: null,
	startTimerID: null,

	startTimer() {
		this.pendingRequestsNumber++;
		if (!this.startTimerID) {
			this.startTimerID = setTimeout(() => {
				window.loader.show = true;
				clearTimeout(this.startTimerID);
				this.startTimerID = null;
			}, LOADER_START_DELAY);
		} else {
			window.loader.show = true;
			clearTimeout(this.startTimerID);
			this.startTimerID = null;
		}
	},

	stopTimer() {
		if (this.pendingRequestsNumber) {
			this.pendingRequestsNumber--;
			if (this.stopTimerID) {
				clearTimeout(this.stopTimerID);
				this.stopTimerID = null;
			}
			this.stopTimerID = setTimeout(() => {
				if (this.pendingRequestsNumber == 0) {
					window.loader.show = false;
					this.stopTimerID = null;
				}
			}, LOADER_STOP_DELAY);
			if (this.startTimerID) {
				clearTimeout(this.startTimerID);
				this.startTimerID = null;
			}
		}
	}
};

const exceptions = [
	'/apps/search/autosuggest'
];

window.axios.interceptors.request.use(function (config) {
	if (!exceptions.includes(config.url)) {
		loader.startTimer();
	}
	return config;
}, function (error) {
	loader.stopTimer();
	return Promise.reject(error);
});

window.axios.interceptors.response.use(function (response) {
	loader.stopTimer();
	return Promise.resolve(response);
}, function (error) {
	loader.stopTimer();
	return Promise.reject(error);
});

export default {
	name: 'full-page-loader',
	data() {
		return {
			loader: window.loader
		};
	}
};



// WEBPACK FOOTER //
// ../source/common/loader/loader.js